/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from '@angular/core';
import { LegalEntityModel, LegalEntityVo } from '@well/common-libs/legal-entity-management/domain-model';

@Pipe({
  name: 'legalEntityVoToDto',
  standalone: true,
})
export class LegalEntityVoToDtoPipe implements PipeTransform {

  transform(value: LegalEntityVo[], ...args: unknown[]): (LegalEntityModel | null)[] {
    return value.map((legalEntityVo) => LegalEntityVo.mapToDto(legalEntityVo));
  }
}
